import { h } from "preact";
import { Link, RoutableProps } from "preact-router";
import { useCallback, useState } from "preact/hooks";
import { useEditor } from "../../../hooks/useEditor";
import { Button, Checkbox, Container, Errorbar, FormField } from "uitoolkit";
import { isValidEmail } from "services/utils";
import { usePageTitle } from "../../../hooks/usePageTitle";
import { globalUserState, login } from "state";
import { translate } from "services/translations";

const initialData = { email: "", password: "", rememberme: true };

type ForgotPasswordProps = ({ navForgotPassword: () => void } | { forgotPasswordUrl: string; });

export const LoginBox = (props: RoutableProps & { onLogin: () => void } & ForgotPasswordProps) => {
    usePageTitle(translate("login_pagetitle"));

    const [feedback, setFeedback] = useState("");
    const [showValidation, setShowValidation] = useState(false);
    const [waiting, setWaiting] = useState(false);
    const { data, handleInputChange } = useEditor(initialData);
    //console.log(data);

    const onLogin = useCallback(async () => {
        setShowValidation(true);
        if (!data.email || !data.password) return;
        setShowValidation(false);
        setWaiting(true);
        globalUserState.value = { ...globalUserState.peek(), rememberMe: data.rememberme }
        const isLoggedIn = await login(data.email, data.password);
        setWaiting(false);
        if (isLoggedIn) {
            setFeedback("");
            props.onLogin()
            return;
        }
        setFeedback(translate("login_feedback_invalid"));
    }, [data.email, data.password])

    const handleEnter = useCallback((e: KeyboardEvent) => {
        if (e.key == "Enter")
            onLogin();
    }, [onLogin]);

    return (
        <Container class="component-form flex-column gap-16" onKeyUp={handleEnter}>
            <header>
                <h1>{translate("login_title")}</h1>
                <h2>{translate("login_description")}</h2>
            </header>
            {
                feedback && <Errorbar class="orange">{feedback}</Errorbar>
            }
            <FormField
                id="email"
                type="email"
                label={translate("login_email_label")}
                placeholder={translate("login_email_placeholder")}
                value={data.email}
                autoComplete=""
                state={!showValidation ? undefined : (!isValidEmail(data.email) ? "invalid" : "valid")}
                onChange={handleInputChange}
                disabled={waiting} />
            <FormField
                id="password"
                type="password"
                label={translate("login_password_label")}
                placeholder=""
                value={data.password}
                autoComplete=""
                state={!showValidation ? undefined : (data.password.length < 6 ? "invalid" : "valid")}
                onChange={handleInputChange}
                disabled={waiting} />
            <div className="forgot">
                <Checkbox
                    id="rememberme"
                    label={translate("login_rememberme_label")}
                    checked={data.rememberme}
                    onChange={handleInputChange} />
            </div>
            <Button
                variant="primary"
                size="large"
                class="wide"
                onClick={onLogin}
                disabled={waiting}>{translate("login_button_login")}</Button>
            <div className="forgot">
                {
                    ("forgotPasswordUrl" in props) &&
                    <Link href={props.forgotPasswordUrl}>{translate("login_forgot_password")}</Link>
                }
                {
                    ("navForgotPassword" in props) &&
                    <a onClick={props.navForgotPassword}>{translate("login_forgot_password")}</a>
                }
            </div>
        </Container>
    );
};
